import { useEffect, useMemo, useState } from "react";
import { FiSearch } from "react-icons/fi";
import { Button, Form, Table } from "react-bootstrap";
import { FaEdit, FaLock, FaLockOpen, FaPlus, FaRegTrashAlt, FaTrashAlt } from "react-icons/fa";
import { NoDataFoundTable } from "../../Hooks/NoDataFoundTable";
import MailEditor from "./MailEditor";
import UseToggle from "../../Hooks/UseToggle";
import Pagination from "../../Hooks/Pagination";
import TempMailActivity from "./TempMailActivity";
import AddTemplate from "./AddTemplate";
import UpdateTemplate from "./UpdateTemplate";
import Swal from "sweetalert2";
import { mailServices } from "../../APIServices/GlobalManagement/mailServices";
import DeletedMailTemplate from "./DeletedMailTemplate";

const MailTemplate = () => {
  const toggles = UseToggle();
  const tabs = [
    { key: "mailEditor", label: "Mail Editor" },
    { key: "preview", label: "Preview" },
    { key: "activity", label: "Activity" },
  ];
  const [searchData, setSearchData] = useState("");
  const [mailTemplateList, setMailTemplateList] = useState([]);
  const [mailTemplateCount, setMailTemplateCount] = useState(0);
  const [singleMailTemplate, setSingleMailTemplate] = useState("");

  const [deletedMailTemplate, setDeletedMailTemplate] = useState([]);
  const [deletedMailTemplateCount, setDeletedMailTemplateCount] = useState(0);

  const [mailTemplatedata, setMailTemplatedata] = useState("");
  const [openPreview, setOpenPreview] = useState(false);
  const [openModule, setOpenModule] = useState("mailEditor");
  const [previewHTML, setPreviewHTML] = useState("");

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const totalPage = Math.ceil(mailTemplateCount / itemsPerPage);

  const [pageNumberDeleted, setPageNumberDeleted] = useState(1);
  const [itemsPerPageDeleted, setItemsPerPageDeleted] = useState(10);

  const getMailTemplateList = async () => {
    let data = await mailServices.getMailTemplateList(
      "active",
      searchData,
      pageNumber,
      itemsPerPage
    );
    setMailTemplateList(data?.data || []);
    setMailTemplateCount(data?.count || 0);
  };

  const getDeletedMailTemplateList = async () => {
    let data = await mailServices.getMailTemplateList(
      "deleted",
      "",
      pageNumberDeleted,
      itemsPerPageDeleted
    );
    setDeletedMailTemplate(data?.data || []);
    setDeletedMailTemplateCount(data?.count || 0);
  };

  const softDeleteRestoreMailTemplate = async (formId, type) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to ${type} mail femplate?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: `Yes, ${type} it!`,
    }).then(async (result) => {
      if (!result.isConfirmed) return;
      const userData = { formId, type };
      const data = await mailServices.softDeleteRestoreMailTemplate(userData);
      if (data?.statusCode === 200) {
        getMailTemplateList();
        getDeletedMailTemplateList();
      }
    });
  };

  const updatedLockMailTemplate = async (mailId, lockStatus) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to ${lockStatus ? "lock" : "unlock"} Template?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
    }).then(async (result) => {
      if (!result.isConfirmed) return;
      const userData = { mailId, lockType: true, lockStatus };
      const data = await mailServices.updatedMailTemplate(userData);
      if (data?.statusCode === 200) getMailTemplateList();
    });
  };

  useEffect(() => {
    getMailTemplateList();
  }, [searchData, pageNumber, itemsPerPage]);

  const activityLogs = [
    {
      _id: "685fe349e3572b7f40c4253a",
      uniqueId: "4159063841",
      activityBy: "fgifa9202089",
      form: "studyeventformschema",
      activities: "Schema Name have been successfully added to the Schema.",
      updatedValue: "Schema001",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:42:49.480Z",
      updatedAt: "2025-06-28T12:42:49.480Z",
      fullName: "Gaurav Chauhan"
    },
    {
      _id: "685fe349e3572b7f40c4253b",
      uniqueId: "4159063841",
      activityBy: "fgifa9202089",
      form: "studyeventformschema",
      activities: "Assign Date have been successfully added to the Schema.",
      updatedValue: "2025-06-18",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:42:49.480Z",
      updatedAt: "2025-06-28T12:42:49.480Z",
      fullName: "Gaurav Chauhan"
    },
    {
      _id: "685fe38ce3572b7f40c42594",
      uniqueId: "9221752978",
      activityBy: "fgifa9202089",
      form: "eventMetadata",
      activities: "Column Label has been successfully added to the event metadata.",
      updatedValue: "Event Number",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:43:56.257Z",
      updatedAt: "2025-06-28T12:43:56.257Z",
      fullName: "Gaurav Chauhan"
    },
    {
      _id: "685fe38ce3572b7f40c42595",
      uniqueId: "9221752978",
      activityBy: "fgifa9202089",
      form: "eventMetadata",
      activities: "Column Name has been successfully added to the event metadata.",
      updatedValue: "EVENNUM",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:43:56.257Z",
      updatedAt: "2025-06-28T12:43:56.257Z",
      fullName: "Gaurav Chauhan"
    },
    {
      _id: "685fe38ce3572b7f40c42596",
      uniqueId: "9221752978",
      activityBy: "fgifa9202089",
      form: "eventMetadata",
      activities: "Column Type has been successfully added to the event metadata.",
      updatedValue: "text",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:43:56.257Z",
      updatedAt: "2025-06-28T12:43:56.257Z",
      fullName: "Gaurav Chauhan"
    },
    {
      _id: "685fe39ae3572b7f40c4259b",
      uniqueId: "8479077403",
      activityBy: "fgifa9202089",
      form: "eventMetadata",
      activities: "Column Label has been successfully added to the event metadata.",
      updatedValue: "Event Name",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:44:10.999Z",
      updatedAt: "2025-06-28T12:44:10.999Z",
      fullName: "Gaurav Chauhan"
    },
    {
      _id: "685fe39ae3572b7f40c4259c",
      uniqueId: "8479077403",
      activityBy: "fgifa9202089",
      form: "eventMetadata",
      activities: "Column Name has been successfully added to the event metadata.",
      updatedValue: "EVENTNAM",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:44:10.999Z",
      updatedAt: "2025-06-28T12:44:10.999Z",
      fullName: "Gaurav Chauhan"
    },
    {
      _id: "685fe39ae3572b7f40c4259d",
      uniqueId: "8479077403",
      activityBy: "fgifa9202089",
      form: "eventMetadata",
      activities: "Column Type has been successfully added to the event metadata.",
      updatedValue: "text",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:44:10.999Z",
      updatedAt: "2025-06-28T12:44:10.999Z",
      fullName: "Gaurav Chauhan"
    },
    {
      _id: "685fe3b0e3572b7f40c425b2",
      uniqueId: "2902156162",
      activityBy: "fgifa9202089",
      form: "eventData",
      activities: "Event Id have been successfully added.",
      updatedValue: "V0_SCR",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:44:32.481Z",
      updatedAt: "2025-06-28T12:44:32.481Z",
      fullName: "Gaurav Chauhan"
    },
    {
      _id: "685fe3b0e3572b7f40c425b3",
      uniqueId: "2902156162",
      activityBy: "fgifa9202089",
      form: "eventData",
      activities: "Event Label have been successfully added.",
      updatedValue: "Screening",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:44:32.481Z",
      updatedAt: "2025-06-28T12:44:32.481Z",
      fullName: "Gaurav Chauhan"
    },
    {
      _id: "685fe3b0e3572b7f40c425b4",
      uniqueId: "2902156162",
      activityBy: "fgifa9202089",
      form: "eventData",
      activities: "Event Day have been successfully added.",
      updatedValue: "-30",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:44:32.481Z",
      updatedAt: "2025-06-28T12:44:32.481Z",
      fullName: "Gaurav Chauhan"
    },
    {
      _id: "685fe3b0e3572b7f40c425b5",
      uniqueId: "2902156162",
      activityBy: "fgifa9202089",
      form: "eventData",
      activities: "Event Name have been successfully added.",
      updatedValue: "Screening",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:44:32.481Z",
      updatedAt: "2025-06-28T12:44:32.481Z",
      fullName: "Gaurav Chauhan"
    },
    {
      _id: "685fe3b1e3572b7f40c425c2",
      uniqueId: "9112213509",
      activityBy: "fgifa9202089",
      form: "eventData",
      activities: "Event Id have been successfully added.",
      updatedValue: "V1_D0",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:44:33.673Z",
      updatedAt: "2025-06-28T12:44:33.673Z",
      fullName: "Gaurav Chauhan"
    },
    {
      _id: "685fe3b1e3572b7f40c425c3",
      uniqueId: "9112213509",
      activityBy: "fgifa9202089",
      form: "eventData",
      activities: "Event Label have been successfully added.",
      updatedValue: "Visit 1 Day 0",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:44:33.673Z",
      updatedAt: "2025-06-28T12:44:33.673Z",
      fullName: "Gaurav Chauhan"
    },
    {
      _id: "685fe3b1e3572b7f40c425c4",
      uniqueId: "9112213509",
      activityBy: "fgifa9202089",
      form: "eventData",
      activities: "Event Day have been successfully added.",
      updatedValue: "0",
      actionType: "add",
      __v: 0,
      createdAt: "2025-06-28T12:44:33.673Z",
      updatedAt: "2025-06-28T12:44:33.673Z",
      fullName: "Gaurav Chauhan"
    }
  ]

  const FormActivity = useMemo(() => {
    const grouped = {};

    activityLogs.forEach((item) => {
      const date = new Date(item.createdAt).toISOString().split("T")[0];
      if (!grouped[date]) grouped[date] = [];

      grouped[date].push({
        module: item.form || "Unknown Module",
        type: item.actionType || "Unknown Type",
        activities: item.activities,
        prevoiusValue: item.prevoiusValue,
        updatedValue: item.updatedValue,
        activityByName: item.fullName,
        createdAt: item.createdAt,
      });
    });

    return Object.entries(grouped)
      .map(([date, data]) => ({
        date,
        data: data.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        ),
      }))
      .sort((a, b) => new Date(b.date) - new Date(a.date));
  }, [activityLogs]);

  const getSingleMailTemplate = async () => {
    let data = await mailServices.getSingleMailTemplate(mailTemplatedata?.mailId);
    setSingleMailTemplate(data?.data || "");
  };

  useEffect(() => {
    if (mailTemplatedata) {
      getSingleMailTemplate()
    }
  }, [mailTemplatedata]);
  
  return (
    <>
    <div style={{ background: "#eee" }}>
      <div className="p-2 d-flex gap-2">
        <div className={`meta-table overflow-auto`} style={{ height: "calc(100vh - 71px)", flex: openPreview ? ".5 0 " : ""}}>
          <div className="hstack gap-2 pb-2 bg-white">
            <Button
              size="sm"
              variant="outline-primary"
              className="hstack gap-2 text-nowrap rounded-1 border"
              style={{ fontSize: 13 }}
              onClick={toggles.setToggle}
            >
              <FaPlus /> {!openPreview && "Add New"}
            </Button>
            <div className="search-box position-relative w-100">
              <FiSearch />
              <Form.Control
                type="search"
                className="w-100 rounded-1"
                style={{ fontSize: 13 }}
                placeholder="Search..."
                value={searchData}
                onChange={(e) => setSearchData(e.target.value)}
              />
            </div>
            {deletedMailTemplateCount > 0 && (
              <Button
                variant="outline-danger"
                className="hstack gap-2 text-nowrap rounded-1 border"
                style={{ fontSize: 13 }}
                onClick={toggles.setToggle2}
              >
                <FaRegTrashAlt /> {!openPreview && "Deleted History"}
              </Button>
            )}
          </div>
          <div className="overflow-auto" style={{ height: "calc(100vh - 122px)"}}>
            {mailTemplateCount === 0 ? (
              <NoDataFoundTable MSG="No Template." />
            ) : (
              <>
                <Table hover responsive className="">
                  <thead className="position-sticky" style={{ top: -1 }}>
                    <tr>
                      <th style={{ width: 45 }} className="text-center">
                        Sr.
                      </th>
                      <th>Template Name</th>
                      {!openPreview && (
                        <>
                          <th className="text-center">Lock</th>
                          <th className="text-center" style={{ width: 80 }}>
                            Actions
                          </th>
                        </>
                      )}
                    </tr>
                  </thead>

                  <tbody>
                    {mailTemplateList?.map((item, index) => (
                      <tr
                        key={index}
                        className={
                          mailTemplatedata?.mailId === item.mailId ? "selectedRow CP" : "CP"
                        }
                        onClick={() => {
                          setOpenPreview(true);
                          setMailTemplatedata(item);
                        }}
                      >
                        <td className="text-center">{startIndex + index + 1}</td>
                        <td>
                          <strong>{item.name}</strong>
                          <div className="sub-text">
                            Created At: 12 Dec 2025 : 14:56
                          </div>
                        </td>
                        {!openPreview && (
                          <>
                            <td
                              className="text-center CP"
                              title="Lock Status"
                              onClick={(e) => {
                                e.stopPropagation();
                                updatedLockMailTemplate(item.mailId, !item.lockStatus);
                              }}
                            >
                              {item.lockStatus ? (
                                <FaLock className="text-success" />
                              ) : (
                                <FaLockOpen className="text-danger" />
                              )}
                            </td>
                            <td className="text-center actions">
                              <FaEdit title="Edit" className={`icon CP ${item.lockStatus ? "disabled" : ""}`} onClick={(e) => {e.stopPropagation(); toggles?.setToggle1();} } />
                              <FaTrashAlt
                                title="Delete"
                                onClick={(e) => {e.stopPropagation();
                                if (!item.lockStatus) {
                                    softDeleteRestoreMailTemplate(
                                      item.mailId,
                                      "delete"
                                    );
                                  }} }
                                className={`icon danger CP ${item.lockStatus ? "disabled" : ""}`}
                              />
                            </td>
                          </>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </Table>
                <div className="position-sticky bottom-0 start-0">
                  <Pagination
                    totalPage={totalPage}
                    pageNumber={pageNumber}
                    itemsPerPage={itemsPerPage}
                    totalItems={mailTemplateCount?.totalItems}
                    setPageNumber={setPageNumber}
                    setItemsPerPage={setItemsPerPage}
                  />
                </div>
              </>
            )}
          </div>
        </div>

        {openPreview && (
          <div className="meta-preview" style={{ flex: "1.5 0" }}>
            <div className="preview-header hstack justify-content-between">
              <div className="hstack gap-2">
                {tabs.map((tab) => (
                  <Button
                    key={tab.key}
                    size="sm"
                    style={{ fontSize: 13 }}
                    variant={
                      openModule === tab.key ? "primary" : "outline-primary"
                    }
                    onClick={() => setOpenModule(tab.key)}
                  >
                    {tab.label}
                  </Button>
                ))}
              </div>
              <Button
                size="sm"
                style={{ fontSize: 13 }}
                variant="outline-danger"
                onClick={() => setOpenPreview(false)}
              >
                Close
              </Button>
            </div>
            {openModule === "mailEditor" && (
              <MailEditor
                previewHTML={previewHTML}
                setPreviewHTML={setPreviewHTML}
                singleMailTemplate={singleMailTemplate}
                getSingleMailTemplate={getSingleMailTemplate}
              />
            )}
            {openModule === "preview" && (
              <div
                className="position-relative w-100 overflow-hidden"
                style={{ height: "calc(100vh - 123px)" }}
              >
                <iframe
                  title="Template Preview"
                  className="w-100 h-100 border-0"
                  srcDoc={previewHTML}
                />
              </div>
            )}
            {openModule === "activity" && <TempMailActivity />}
          </div>
        )}
      </div>
    </div>
    <AddTemplate
      Show={!toggles?.toggle}
      Hide={toggles?.setToggle}
      Title={`Add Template`}
      getMailTemplateList={getMailTemplateList}
      />
      
      <UpdateTemplate
        Show={!toggles?.toggle1}
        Hide={toggles?.setToggle1}
        Title={`Update Template`}
        mailTemplatedata={mailTemplatedata}
        getMailTemplateList={getMailTemplateList}
      />

      <DeletedMailTemplate
        Show={!toggles.toggle2}
        Hide={toggles.setToggle2}
        Title={`Restore Mail Templates`}
        deletedMailTemplate={deletedMailTemplate}
        softDeleteRestoreMailTemplate={softDeleteRestoreMailTemplate}
        deletedMailTemplateCount={deletedMailTemplateCount}
        pageNumberDeleted={pageNumberDeleted}
        itemsPerPageDeleted={itemsPerPageDeleted}
        setPageNumberDeleted={setPageNumberDeleted}
        setItemsPerPageDeleted={setItemsPerPageDeleted}
        getDeletedMailTemplateList={getDeletedMailTemplateList}
      />
    </>
  );
};

export default MailTemplate;
